// Shared decoders for customer columns that are stored more loosely than the form renders them.
// Used by both CustomerForm and CustomerForm_v2 so the two do not drift apart.

// The gender picker only offers M/F/Other, so a record holding anything else (older imports and
// document extractions store "Female", "male", ...) renders as an empty selection.
export const normalizeGender = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return 'M';
  const first = raw[0].toUpperCase();
  if (first === 'M') return 'M';
  if (first === 'F') return 'F';
  return 'Other';
};

// cus_address stores "addr1,addr2,city,state,zip" (or "addr1,city,state,zip") per address. Used when
// the stored address does not line up with any company location row, so it stays visible and
// editable instead of being dropped — a dropped address is also lost on the next save.
export const addressFromParts = (addArr) => {
  const [line1, line2, city, state, zip] = addArr.length === 4
    ? [addArr[0], '', addArr[1], addArr[2], addArr[3]]
    : addArr;
  const parts = [line1, line2, city, state, zip].map((p) => (p || '').trim());
  if (!parts.some((p) => !!p)) return null;
  return {
    address_line_1: parts[0],
    address_line_2: parts[1],
    city: parts[2],
    state: parts[3],
    zip: parts[4],
    latitude: 0,
    longitude: 0,
    disableFields: false
  };
};
